/**
 * Extends store with observe mixin
 */

import _, { defer } from 'lodash'

export default function(store) {
    /*
     * Adapted from https://github.com/reactjs/redux/issues/303#issuecomment-125184409
     */
    store.observe = function(select, onChange) {
        let currentState;

        function handleChange() {
            let nextState = select(store.getState());
            if (!_.isEqual(nextState, currentState)) {
                let oldState = currentState;
                currentState = nextState;
                onChange(currentState, oldState);
            }
        }

        let unsubscribe = store.subscribe(handleChange);
        defer(handleChange);
        return unsubscribe;
    };

    return store;
}
